var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_5035_34333)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.902832,
    y: 0.363281,
    width: 62,
    height: 62,
    rx: 31,
    fill: "url(#paint0_linear_5035_34333)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.40283,
    y: 0.863281,
    width: 61,
    height: 61,
    rx: 30.5,
    stroke: "white",
    strokeOpacity: 0.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M32.2495 17.4805C32.4715 17.4805 32.6841 17.534 32.8826 17.6344L41.7792 21.8452C42.8186 22.337 43.5982 23.4799 43.5887 24.8136C43.584 26.1262 43.4659 27.6497 43.1352 29.2891H32.2495V17.4805ZM30.9691 44.0073C24.7986 40.7126 22.1981 34.4184 21.29 29.2891H32.2164V44.3183C31.7486 44.3183 31.3612 44.2129 30.9691 44.0073ZM32.2495 17.4805L32.1739 17.4809H32.1833",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_5035_34333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2168 29.2891H21.2904C21.0003 27.6497 20.8832 26.1262 20.835 24.8136C20.8713 23.4799 21.6486 22.337 22.687 21.8452L31.5884 17.6344C31.7821 17.534 31.9994 17.4805 32.2168 17.4805V29.2891ZM33.4972 44.0073C33.105 44.2129 32.6798 44.3183 32.2498 44.3183V29.2891H43.1355C42.2709 34.4184 39.6676 40.7126 33.4972 44.0073ZM32.2168 17.4805L32.2498 17.4809L32.2168 17.4805Z",
    fill: "url(#paint1_linear_5035_34333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7168 28.7891H21.713C21.4796 27.3422 21.3791 25.9936 21.3352 24.8118C21.3722 23.6662 22.0428 22.7037 22.9009 22.2972C22.9009 22.2971 22.901 22.2971 22.9011 22.2971L31.7168 18.1268V28.7891ZM32.7498 43.7589V29.7891H42.5374C41.5909 34.7217 39.0111 40.4954 33.2635 43.5653C33.0975 43.6521 32.9253 43.7167 32.7498 43.7589Z",
    stroke: "white",
    strokeOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5035_34333",
    x: -4.09717,
    y: -4.63672,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5035_34333"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5035_34333",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_5035_34333",
    x: -1.16504,
    y: -4.51953,
    width: 66.3006,
    height: 70.8359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5035_34333"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5035_34333",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5035_34333",
    x1: -1.6805,
    y1: 64.4299,
    x2: 34.6837,
    y2: -3.70988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.190425,
    stopColor: "#FF5740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902773,
    stopColor: "#FFE419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5035_34333",
    x1: 22.438,
    y1: 19.7929,
    x2: 48.9775,
    y2: 28.5594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/QA.a2a66b0a581b71d47a10f96ffd324a98.svg";
export { ForwardRef as ReactComponent };